import { IUpdatingFormFieldValue } from './formField.interface';

export class FormUtils {
  public static getFieldIndex = <T extends { name?: string }>(fields: T[], fieldName: string): number => {
    return fields.findIndex((field) => field.name === fieldName);
  };

  public static updateFormField = <T extends { name: string }>(
    idx: number,
    value: IUpdatingFormFieldValue,
    fields: T[],
  ): IUpdatingFormFieldValue[] => {
    return (fields[idx] = Object.assign({
      ...fields[idx],
      ...value,
    }));
  };

  public static updateFormFieldByName = <T extends { name: string }>(
    fieldName: string,
    value: IUpdatingFormFieldValue,
    fields: T[],
  ): IUpdatingFormFieldValue[] => {
    const idx = FormUtils.getFieldIndex(fields, fieldName);

    return FormUtils.updateFormField(idx, value, fields);
  };

  public static getFieldsIndices = <I extends { name: string }, T extends object>(
    fields: I[],
    fieldNames: string[],
  ): T => {
    const obj: { [key: string]: number } = {};

    fields.forEach((field) => {
      if (field.name && fieldNames.includes(field.name)) {
        const { name } = field;

        obj[`${name}Idx`] = FormUtils.getFieldIndex(fields, field.name);
      }
    });

    return obj as T;
  };
}
